export default __webpack_public_path__ + "static/media/icon-status-not-done.55366d0f.svg";